module.exports = __webpack_public_path__ + "static/img/6.bb59d58.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/6.png
// module id = 08Xh
// module chunks = 0